import React, { Component } from 'react';
import { connect } from "react-redux";
import { Card } from '../../ui';
import Steps from '../../Steps';
import { setStepsList } from "../../../actions";
import Loader from '../../Common/Loader';
import AlquilerForm from './AlquilerForm';
import PersonalData from './PersonalData';
import LaborData from './LaborData';
import Property from './Property';
import Attached from './Attached';

class GtiaAlquiler extends Component {
  constructor(props) {
    super(props);

    this.state = {
      globalSteps: [
        '1. Datos personales',
        '2. Datos laborales',
        '3. Inmueble',
        '4. Adjuntos'
      ],
      steps: [
        { pos: 0, global: -1, name: 'alquilerForm', backButton: false },
        { pos: 1, global: 0, name: 'personalData', backButton: true },
        { pos: 2, global: 1, name: 'laborData', backButton: true },
        { pos: 3, global: 2, name: 'property', backButton: true },
        { pos: 4, global: 3, name: 'attached', backButton: true },
      ]
    };
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    const { steps } = this.state;
    const { setStepsList } = this.props;
    setStepsList(steps);
  }

  getStepContent() {
    const { selectedStep } = this.props;

    switch (selectedStep.name) {
      case 'alquilerForm':
        return <AlquilerForm />;
      case 'personalData':
        return <PersonalData />;
      case 'laborData':
        return <LaborData />;
      case 'property':
        return <Property />;
      case 'attached':
        return <Attached />;
      default:
        return null;
    }
  }

  render() {
    const { globalSteps } = this.state;
    const { loading } = this.props;

    return (
      <Card className="Card--medium">
        <div style={{ padding: '2rem 1rem 3rem 1rem' }}>
          <Steps globalSteps={globalSteps} />

          <div style={{ paddingTop: '3rem' }}>
            {loading ?
              <Loader /> :
              this.getStepContent()
            }
          </div>
        </div>
      </Card>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    loading: state.steps.isLoading,
    selectedStep: state.steps.selectedStep
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setStepsList: (steps) => {
      dispatch(setStepsList(steps));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GtiaAlquiler);
